import React, { useState } from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Link,
  Typography,
  makeStyles,
} from "@material-ui/core";
import brandTheme from "brandTheme/Theme";

const useStyles = makeStyles(() => ({
  consentContainer: {
    marginTop: 16,
  },
  consentLabel: {
    color: "#555",
    fontSize: 13,
    lineHeight: "20px",
  },
  checkbox: {
    color: brandTheme?.mainColor,
    padding: 4,
    "&.Mui-checked": {
      color: brandTheme?.mainColor,
    },
  },
  formControl: {
    alignItems: "flex-start",
    marginBottom: 12,
    marginLeft: 0,

    "& .MuiFormControlLabel-label": {
      color: "#555",
      fontSize: 13,
      lineHeight: "20px",
    },
  },
  link: {
    color: "#1CB167",
    fontWeight: 500,
    textDecoration: "underline",

    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

const ConsentSection = ({consent, setConsent}) => {
  const classes = useStyles();
  const handleChange = (event) => {
    setConsent((prev) => ({
      ...prev,
      [event.target.name]: event.target.checked,
    }));
  };

  return (
    <Box className={classes.consentContainer}>
      <FormControlLabel
        className={classes.formControl}
        control={
          <Checkbox
            checked={consent.terms}
            onChange={handleChange}
            name="terms"
            className={classes.checkbox}
          />
        }
        label={
          <Typography className={classes.consentLabel}>
            By proceeding, you agree to our{" "}
            <Link
              href="/term-and-conditions"
              target="_blank"
              className={classes.link}
            >
              Terms &amp; Conditions
            </Link>
            ,{" "}
            <Link
              href="/privacy-policy"
              target="_blank"
              className={classes.link}
            >
              Privacy Policy
            </Link>
            , and consent to us accessing your credit information from credit
            bureaus for processing your application.
          </Typography>
        }
      />

      <FormControlLabel
        className={classes.formControl}
        control={
          <Checkbox
            checked={consent.communication}
            onChange={handleChange}
            name="communication"
            className={classes.checkbox}
          />
        }
        label={
          <Typography className={classes.consentLabel}>
            I consent to receive loan-related updates, alerts, and
            communications via <strong>WhatsApp</strong>, <strong>SMS</strong>,{" "}
            <strong>RCS</strong>, and any other communication channel on my
            registered mobile number.
          </Typography>
        }
      />

      <FormControlLabel
        className={classes.formControl}
        control={
          <Checkbox
            checked={consent.ckyc}
            onChange={handleChange}
            name="ckyc"
            className={classes.checkbox}
          />
        }
        label={
          <Typography className={classes.consentLabel}>
            I hereby provide my consent to fetch and verify my KYC details from
            the CKYC registry for the purpose of processing my application.
          </Typography>
        }
      />
    </Box>
  );
};

export default ConsentSection;